import { Icon } from "@-/dev.improve.haniverse.components.ui.icon";
import { Pressable, View } from "@-/com.npmjs.react-native";
import { Text } from "@-/dev.improve.haniverse.components.ui.text";
import {
  GlassContentScope,
  ToolbarGlassSurface,
} from "@-/dev.improve.haniverse.components.ui.toolbar.button.view";
import type { StyleProp, ViewStyle } from "@-/com.npmjs.react-native";
import { cn } from "@-/com.npmjs.cn";

/**
 * Glass "show more" affordance. `floating` centers it over the bottom of a card; the caller owns
 * visibility (e.g. "only while there's more content below") and the `onPress` that enables
 * scrolling and advances the content. `inline` lays it out in the content flow instead, for cards
 * that collapse whatever would overflow and reveal it in place.
 */
export function ScrollToBottomButton({
  className,
  label = "Show More",
  onPress,
  placement = "floating",
  style,
}: {
  className?: string;
  label?: string;
  onPress: () => void;
  placement?: "floating" | "inline";
  style?: StyleProp<ViewStyle>;
}) {
  return (
    <View
      className={cn(
        placement === "floating" ? "absolute inset-x-0 bottom-3 items-center" : "items-center",
        className,
      )}
      pointerEvents="box-none"
      style={style}
    >
      <Pressable
        accessibilityLabel={label}
        accessibilityRole="button"
        className="min-h-11 flex-row items-center justify-center gap-1.5 rounded-full px-4 py-2"
        onPress={onPress}
      >
        {/* The label sits beside the glass, not in it, so both share one scope. */}
        <GlassContentScope>
          <ToolbarGlassSurface
            accessible={false}
            className="absolute inset-0"
            interactive={false}
            pointerEvents="none"
          />
          <Text className="text-sm font-medium text-foreground">{label}</Text>
          <Icon className="text-foreground" name="LuChevronDown" size={18} />
        </GlassContentScope>
      </Pressable>
    </View>
  );
}
